(function() {
  'use strict';

  angular.module('blocks.security', []);
})();
